module.exports = __webpack_public_path__ + "static/media/1005144.4d4cfbde.png";